import React from "react";
import { TableHeadersType } from "../../../../constant/tableHeadersConstants/tableHeadersType";
import { TotalBalancetype } from "../../../../redux/reports/reportsType";
import { getData } from "../../Grouping/common";
import GroupingTableHeader from "../../Grouping/GroupingTableHeader";
import { currencySignAndNegativeValueAdjust } from "../../../../utils/commonFunctions";
import DetailedTrialBalaceTableData from "./DetailedTrialBalaceTableData";
import "./DetailedTrilBalance.scss";

type AppProps = {
  trialBalanceData: any;
  client_code: number;
  company_name: string;
  tableHeaders: TableHeadersType[];
  totalBalances: TotalBalancetype;
  start_date: string;
  end_date: string;
  isLedgerStatementPresent?: boolean;
  currencySign: string | undefined;
  handleCustomerSuplierDetailsData: (invoiceType: number) => void;
  tableCaption: string;
  showGrandTotal: boolean;
  grandTotal: any;
};

const DetailedTrialBalaceTable = ({
  trialBalanceData,
  client_code,
  tableHeaders,
  totalBalances,
  company_name,
  start_date,
  end_date,
  isLedgerStatementPresent,
  currencySign,
  handleCustomerSuplierDetailsData,
  tableCaption,
  showGrandTotal,
  grandTotal,
}: AppProps) => {
  const getFormattedBalance = (balance: number | undefined): string => {
    if (!balance) return "0";
    return balance.toFixed(2).toString();
  };

  const renderFooter = (trialBalanceData: any) => {
    let finalData = tableHeaders?.map((thead: any) => {
      if (thead?.value === "ledger_name") {
        return (
          <td style={{ borderTop: "none" }}>
            <p className={"reports-total"}>Total Amount</p>
          </td>
        );
      }
      if (thead?.value === "opening_balance") {
        return (
          <td style={{ borderTop: "none" }}>
            <p className={"reports-total"}>
              {currencySignAndNegativeValueAdjust(currencySign, getFormattedBalance(trialBalanceData?.opening_balance))}
            </p>
          </td>
        );
      }
      if (thead?.value === "total_debit_amount") {
        return (
          <td style={{ borderTop: "none" }}>
            <p className={"reports-total"}>
              {currencySignAndNegativeValueAdjust(
                currencySign,
                trialBalanceData?.total_debit_amount
                  ? trialBalanceData?.total_debit_amount?.toFixed(2)?.toString()
                  : "0"
              )}
            </p>
          </td>
        );
      }
      if (thead?.value === "total_credit_amount") {
        return (
          <td style={{ borderTop: "none" }}>
            <p className={"reports-total"}>
              {currencySignAndNegativeValueAdjust(
                currencySign,
                trialBalanceData?.total_credit_amount
                  ? trialBalanceData?.total_credit_amount?.toFixed(2)?.toString()
                  : "0"
              )}
            </p>
          </td>
        );
      }
      if (thead?.value === "closing_balance") {
        return (
          <td style={{ borderTop: "none" }}>
            <p className={"reports-total"}>
              {currencySignAndNegativeValueAdjust(currencySign, getFormattedBalance(trialBalanceData?.closing_amount))}
            </p>
          </td>
        );
      }
    });
    return finalData;
  };

  const renderbody = (trialBalanceSectionData: any) => {
    const newData = trialBalanceSectionData?.slice(0, -1);
    return (
      <>
        {getData(newData)?.map((singleData: any, index: number) => (
          <DetailedTrialBalaceTableData
            key={index}
            tableHeaders={tableHeaders}
            singleData={singleData}
            totalBalances={totalBalances}
            client_code={client_code}
            company_name={company_name}
            start_date={start_date}
            end_date={end_date}
            isLedgerStatementPresent={isLedgerStatementPresent}
            handleCustomerSuplierDetailsData={handleCustomerSuplierDetailsData}
            currencySign={currencySign}
            count={1}
            index={index + 1}
          />
        ))}
      </>
    );
  };
  return (
    <>
      <div className="grouping table-responsive">
        <table className="table table-bordered">
          <caption>{tableCaption}</caption>
          <thead className="sticky-table-header-without-zindex">
            <GroupingTableHeader isFoDetailedTrialBalance={true} tableHeader={tableHeaders} />
          </thead>
          <tbody>{renderbody(trialBalanceData)}</tbody>
          <tfoot>
            <tr className="section-footer">{renderFooter(trialBalanceData?.[trialBalanceData?.length - 1])}</tr>
            {showGrandTotal && grandTotal && (
              <>
                <tr>
                  <td
                    colSpan={tableHeaders?.length}
                    style={{ height: "24px", border: "none", backgroundColor: "white" }}
                  />
                </tr>
                <tr className="grand-total">{renderFooter(grandTotal)}</tr>
              </>
            )}
          </tfoot>
        </table>
      </div>
    </>
  );
};

export default DetailedTrialBalaceTable;
